module.exports = __webpack_public_path__ + "static/media/modal_drlicita.ed49b094.png";